import { supabase } from "../lib/supabase";
import {
  usePendingFollowUps as usePendingFollowUpsImpl,
  usePendingFollowUpsCount as usePendingFollowUpsCountImpl,
} from "@trade-connector/shared/hooks/usePendingFollowUps";

export type {
  PendingFollowUpWorkflow,
  UsePendingFollowUpsOptions,
} from "@trade-connector/shared/hooks/usePendingFollowUps";

export function usePendingFollowUps(
  userId: string | null | undefined,
  options?: import("@trade-connector/shared/hooks/usePendingFollowUps").UsePendingFollowUpsOptions,
) {
  return usePendingFollowUpsImpl(supabase, userId, options);
}

export function usePendingFollowUpsCount(
  userId: string | null | undefined,
  options?: import("@trade-connector/shared/hooks/usePendingFollowUps").UsePendingFollowUpsOptions,
) {
  return usePendingFollowUpsCountImpl(supabase, userId, options);
}
